import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/sales/outlets/";

export function getOutlets() {
  return http.get(apiEndpoint);
}

export function getAllOutlets() {
  return http.get(apiEndpoint + "all-outlets");
}

export function getOutlet(outletID) {
  return http.get(apiEndpoint + "outlet-detail/" + outletID);
}

export function getOutletStocks(outletID, itemID = 0, varCode = "") {
  if (varCode === "") {
    varCode = "-";
  }
  return http.get(
    apiEndpoint + "stocks/" + outletID + "/" + itemID + "/" + varCode
  );
}

export function getOutletMasterDataAPI() {
  return http.get(apiEndpoint + "outlet-master-data");
}

export function saveOutlet(outlet) {
  if (outlet.ID === 0) {
    return http.post(apiEndpoint, outlet);
  } else {
    return http.put(apiEndpoint, outlet);
  }
}

export function getOutletItemVariantDetail(outletID, itemID) {
  return http.get(
    apiEndpoint + "outlet-item-variant-detail/" + outletID + "/" + itemID
  );
}

export function saveOutletItemVariantDetail(itemVariants) {
  return http.post(apiEndpoint + "outlet-item-variant-detail", itemVariants);
}

export function getOutletSellItems(outletID) {
  return http.get(apiEndpoint + "outlet-sell-items/" + outletID);
}

export function getAllSellItems(outletID) {
  return http.get(apiEndpoint + "all-sell-items/" + outletID);
}

export function getOutletPendingReceivedItems(outletID) {
  return http.get(apiEndpoint + "outlet-pending-received-items/" + outletID);
}

export function saveOutletReceivedItems(receivedItems) {
  return http.post(apiEndpoint + "outlet-received-items", receivedItems);
}

export function saveOutletSellItem(outletSellItem) {
  return http.post(apiEndpoint + "outlet-sell-items", outletSellItem);
}

export function getOutletCashAccount(outletID) {
  return http.get(apiEndpoint + "outlet-cash-account/" + outletID);
}

export function saveOutletCashAccount(cashAccount) {
  return http.post(apiEndpoint + "outlet-cash-account", cashAccount);
}

export function deleteOutlet(outletID) {
  return http.delete(apiEndpoint + outletID);
}

export function restoreOutlet(outletID) {
  return http.put(apiEndpoint + outletID);
}
